import {Component, EventEmitter, Input, Output, OnChanges, SimpleChanges} from '@angular/core';
import { RmService } from '@bidi/common-services';
import { createFeatureSelector, select, Store } from '@ngrx/store';

import { CommentsResourcesService } from './comments-resources.service';
import {LoadingComments, SetCommentsResourcesSaved} from './ngrx/actions';
import {Observable} from 'rxjs';

@Component({
  selector: 'bidi-comments-resources',
  templateUrl: './comments-resources.component.html',
  styleUrls: ['./comments-resources.component.scss']
})
export class CommentsResourcesComponent implements OnChanges {
  @Input() resourceId;
  @Input() role;
  @Input() title;
  @Output() close = new EventEmitter();
  comment: string;

  private state$ = this.store.pipe(select(createFeatureSelector('@bidi/common-components Ratings')));

  constructor (
    private rm: RmService,
    public commentsService: CommentsResourcesService,
    private store: Store<any>
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.store.dispatch(new LoadingComments(true));
    this.commentsService.getComments(this.resourceId);
  }

  saveComment() {
    const data = {
      'resource': this.resourceId,
      'comment': this.comment,
      'type': this.role
    };

    this.store.dispatch(new LoadingComments(true));
    this.store.dispatch(new SetCommentsResourcesSaved(data));
    this.comment = '';
  }
}
